import { render, staticRenderFns } from "./BrandFormView.vue?vue&type=template&id=327659d0&"
import script from "./BrandFormView.vue?vue&type=script&lang=js&"
export * from "./BrandFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports